import { WGUIKIT, getB2bDefaultSettings } from './wguikit-lib.js';

window.addEventListener('load', () => {
    window['WGUIKIT'] = new WGUIKIT({
        settings: getB2bDefaultSettings(),
    });

    window['WGUIKIT'].setup();
});
